import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const OcMasterAPI = {

  index: async function (cancel = false) {
    const response = await api.request({
      url: "/oc-master",
      method: "GET",
      signal: cancel ? cancelApiObject[this.index.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },

  // método para el listado paginado/filtrado de Follow Up
  listFollowUp: async function (params = {}, cancel = false) {
    const response = await api.request({
      url: "/oc-master/follow-up",
      method: "GET",
      params: params, // Pasa { page, per_page, search }
      signal: cancel ? cancelApiObject[this.listFollowUp.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },

  // método para obtener la línea de tiempo de una orden
  getTimeline: async function (id, cancel = false) {
    const response = await api.request({
      url: `/oc-master/${id}/timeline`,
      method: "GET",
      signal: cancel ? cancelApiObject[this.getTimeline.name].handleRequestCancellation().signal : undefined,
    })

    return response.data
  },
}



// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(OcMasterAPI)